import React from 'react';
import { cn } from '../lib/utils';

const buttonVariants = {
  primary: 'btn-primary',
  secondary: 'btn-secondary',
  ghost: 'btn-ghost',
  outline: 'border-2 border-primary-text-dark text-primary-text-dark hover:bg-primary-text-dark hover:text-white'
};

const buttonSizes = {
  sm: 'btn-sm',
  md: 'px-6 py-3 text-base',
  lg: 'btn-lg'
};

/**
 * Button Component
 * Professional button component with multiple variants and sizes
 */
const Button = React.forwardRef(({
  className,
  variant = 'primary',
  size = 'md',
  children,
  icon: Icon,
  iconPosition = 'left',
  ...props
}, ref) => {
  return (
    <button
      className={cn(
        'btn',
        buttonVariants[variant],
        buttonSizes[size],
        className
      )}
      ref={ref}
      {...props}
    >
      {Icon && iconPosition === 'left' && (
        <Icon className="w-5 h-5 mr-2" />
      )}
      {children}
      {Icon && iconPosition === 'right' && (
        <Icon className="w-5 h-5 ml-2" />
      )}
    </button>
  );
});

Button.displayName = 'Button';

export default Button;
